<template>
  <ProductType
    v-if="types.length"
    :id
    v-model="selectedTypeId"
    :types="types"
    class="margin-bottom-xs"
    :label="label || 'Orientation'"
    :name="`cta-types-${uniqueId}-${id}`"
    :error-text-active
  />
</template>

<script setup>
import { useId } from 'vue';
import { ProductType } from '@nuxt-common/media-card-large/app/modules/type';
import { useType } from '~/modules/type/composables/useType';
import { useProduct } from '~/modules/product/composables/useProduct';
import useFeatureEligibility from '~/modules/featureControl/composables/useFeatureEligibility';
import useSelectedMemberId from '~/modules/latchkey/composables/useSelectedMemberId';
import { useTraitsErrorActive } from '~/modules/sticky-product-traits/composables/context-providers/useTraitsErrorActive';

const uniqueId = useId();

const { errorTextActive } = useTraitsErrorActive();
const { productId } = useProduct();
const selectedMemberId = useSelectedMemberId();
const { isShopTheSetExpEnabled } = useFeatureEligibility();

const id = computed(() => (isShopTheSetExpEnabled ? selectedMemberId.value : productId));
const { types, selectedTypeId, label } = useType();
</script>
